import { $,_,moment } from '../../vendor'
import { Datepicker } from '../../vendor'

import Inboomai18n from './Inboomai18n'
// @ts-ignore
import InboomaBaseView from './../views/InboomaBaseView'
import AppointmentsGenerator from './AppointmentsGenerator'

/**
 * @class AppointmentPicker
 * @author Felix Albroscheit
 *
 * Backbone component that renders a pikaday calendar using
 * events- and appointments-data and recurrencies class
 *
 * @see clients_scripts/AppointmentPicker/index.html
 * @todo tests
 * @todo Optimize in terms of performance
 */

const t = InboomaBaseView.prototype.t;


export default InboomaBaseView.extend({

    template: _.noop,
    _openPopup : null,
    _sortedEvents : [],
    _prevInputValue : '',
    // @ts-ignore
    _sortedEvents : [], // where key format is 'Y-MM-DD'
    // _allowCalClose : string is used further down to avoid unexpected closing of datepicker

    /**
     * Called after selecting a day + event/appointment + amount.
     * Updates reservation model with that data, closes picker
     * and displays selection details in this.$el.find('input')
     *
     * @todo Should the appointment data on the reservation be set or modified here?
     *
     * @param {jQueryElem} el
     */
    _singleAppointmentClick (el: any): void {

        this._allowCalClose = true;

        const apptId: any = el.attr('data-apptId'),
            day: any = el.attr('data-day'),
            perscount: number = Number(el.find('select').val());

        let _event: any;

        if (apptId) {

            _.each(this._sortedEvents[day], (event, key) => {
                if (typeof event === 'undefined') {
                    return;
                }

                if (event.id == apptId) {
                    _event = event;
                }
            });

            // Hand out event values to (reservation-)model
            // in an API-compatible way;
            // Setting some attributes "silently" to avoid re-rendering
            // of reactive DOM-inputs
            const start: any = moment(_event.start).utc().add(2,'hours'),
                end: any = moment(_event.end).utc().add(2,'hours');

            this.model.set('event_id', _event.id);
            this.model.set('amount', perscount);
            this.model.set('appointment_id', (typeof _event.appointment_id !== 'undefined' ? _event.appointment_id : null));
            this.model.set('begin', start.format('YYYY-MM-DD HH:mm'));
            this.model.set('end', end.format('YYYY-MM-DD HH:mm'));

            console.log('Appointmentpicker after select: Updated reservation model', this.model.toJSON(), _event);

            this._prevInputValue = `${_event.title}, ${start.format('D. MMMM HH:mm')} - ${end.format('D. MMMM YYYY HH:mm')}`;

            this.$el.find('input')
                .val(this._prevInputValue);

        }
    },

    _helperCollectionFetch (): void {

        const that: any = this;

        if (this._sortedEvents.length === 0 && !this._fetchingInProgress) { // Avoids multiple calls on AppointmentsGenerator

            this._fetchingInProgress = true;

            $('.pika-single').addClass('appointment-picker')
                .addClass('appointment-picker-loading');

            AppointmentsGenerator({
                contingent_id : Number(that.options.contingent.get('id')),
                client_id : Number(that.options.clientId),
                begin : moment().format('DD.MM.YYYY'), // Problem: What about events in past?
                end : moment().add(2,'years').format('DD.MM.YYYY')
            })
                .then((appointments: any): void => {

                    $('.pika-single').removeClass('appointment-picker-loading');

                    that._fetchingInProgress = false;
                    that._sortedEvents = appointments;

                    if (appointments.length === 0) {
                        that.$el.find('input')
                            .val(t('no_appointments_for_contingent'))
                    }

                    // re-render cal (no native fn for that...)
                    that.datepicker.hide();
                    //that.datepicker.show();

                })
                .catch((error: any): void => {

                    console.log('Error in catching/generating events', error);

                    $('.pika-single').removeClass('appointment-picker-loading');

                    that._fetchingInProgress = false;

                    that.datepicker.hide();

                    // @ts-ignore
                    new Notification({
                        message : t('request_error'),
                        duration : 5000,
                        type : 'warning',
                        closeable : true,
                        icon : 'fi fi-x'
                    });
                });
        }
    },

    initialize (options: any): void {

        if (typeof options.options !== 'undefined') {
            this.options = options.options;
        }

        if (_.isUndefined(this.options.clientId) || _.isUndefined(this.options.contingent)) {
            console.log('AppointmentPicker: Missing params', this.options);
            return;
        }

        this._triggerHelperCollectionFetch = (typeof this.options.triggerHelperCollectionFetch !== 'undefined'
            ? this.options.triggerHelperCollectionFetch
            : true);

        if (this._triggerHelperCollectionFetch) {
            this._helperCollectionFetch();
        }

        this.render(options);
    },

    _removeDomSpam (): void {

        const domSpam: HTMLCollectionOf<Element> = document.getElementsByClassName('appointments-popup-list');

        if (domSpam.length >= 1) {
            _.each(domSpam, (spam: Element): void => {
                if (typeof spam !== 'undefined') {
                    spam.remove();
                }
            });
        }
    },

    /**
     * Mostly called via event bubbling (OffCanvasBehavior > appChannel > Backform > this)
     * Remove loose containers (if any) from DOM
     */
    onDestroy (): void {

        if (typeof this.datepicker !== 'undefined') {
            this.datepicker.destroy();
        }

        this._removeDomSpam();
    },

    onRender (): any {

        const that: any = this;

        this._allowCalClose = true;

        // If reservation begin was in past, jump to that date. Else, use today.
        let minDate: any = (that.model.get('begin') !== '' ? moment(that.model.get('begin')) : null);

        if (!minDate || minDate.isAfter(moment())) {
            minDate = moment();
        }

        this.datepicker = new Datepicker({

            i18n : Inboomai18n.getPikadayI18n(),
            firstDay : 1, // monday
            field: this.$el.find('input')[0],
            numberOfMonths : 2,
            minDate : minDate.toDate(),
            maxDate: minDate.add(2,'years').toDate(),

            /**
             * OnFocusIn input field
             */
            onOpen (): void {
                if (that._triggerHelperCollectionFetch === false) {
                    that._helperCollectionFetch();
                }
            },

            /**
             * @todo WIP! The idea was to pre-select/auto-open the last selected event-date.
             * However, it's hard to trigger the actual date (.click() not working, call on
             * that.datepicker.selectDate leads to recursion)
             */
            onDraw (): void {
                that._prevInputValue = that.$el.find('input').val();

                if (false || that._sortedEvents.length >= 1) {
                    if (that.model.get('begin') !== '' && that.model.get('contingent_id') === Number(that.options.contingent.get('id'))) {
                        // @todo if (event_id === ...)
                        const begin: any = moment(that.model.get('begin'));
                        const target: JQuery<HTMLElement> = $(`button.pika-day[data-pika-year="${begin.format('YYYY')}"][data-pika-month="${begin.format('M')-1}"][data-pika-day="${begin.format('D')}"]`);
                        target.click(); // Also .submit() / .parent()... does not work :(
                    }
                }
            },

            /**
             * Renders list of available events of day selected as popup
             *
             * @param {Date} day
             *
             * @todo Shift into own (BaseInbooma)view where UI events can
             * be set and removed more accurately.
             */
            onSelect (day: any): void {

                that.$el.find('input')
                    .val(that._prevInputValue);

                that._allowCalClose = false;

                day = moment(day);
                this.show();

                if (that._openPopup !== null) {
                    that._openPopup.remove();
                }

                setTimeout((): void => {
                    // So that focusOut will work again regularly
                    that._allowCalClose = true;
                }, 300);


                const target: JQuery<HTMLElement> = $('td.is-selected').last(),
                    events = that._sortedEvents[day.format('Y-MM-DD')],
                    ddId = day.format('Y-MM-DD'),
                    // @ts-ignore
                    top = $(this.el).offset().top,
                    // @ts-ignore
                    left = $(this.el).offset().left;

                if (events) {

                    // @ts-ignore
                    let filterDuplicates: any = [];

                    let ddText: string = `
                  <div
                      class="appointments-popup-list dropdown-pane is-open"
                      style="top:${top}px;left:${left}px;"
                      id="dd-${ddId}">
                      <h5 class="float-left">
                          ${t('select_appointment')}
                      </h5>
                      <span class="selected-day">
                          ${day.format('dd, DD.MM.YY')}
                      </span>
                      <button
                          type="button"
                          class="hollow secondary float-right button-abort round"
                          data-close>
                          <i class="fi fi-x"></i>
                      </button>
                      <hr />`;

                    _.each(events, (event: any, key: any): void => {

                        if (typeof event === 'undefined' || typeof filterDuplicates[event.id] !== 'undefined') {
                            return;
                        }

                        filterDuplicates[event.id] = true;

                        const start: any = moment(event.start).utc().add(2,'hours'),
                            end: any = moment(event.end).utc().add(2,'hours');

                        let selectedPersCount: number = 0,
                            max_attendees: any = (typeof event.max_attendees !== 'undefined' ? event.max_attendees : that.options.contingent.getNumbersByDay(event.start).number),
                            available_pers_count: any = max_attendees;

                        if (typeof event.current_available_pers_count !== 'undefined') {
                            // Set remaining persons count of linked appointment... (lower than max_attendees when it's a booking)
                            available_pers_count = event.current_available_pers_count;

                            if (typeof event.appointment_id !== 'undefined'
                                && that.model.get('id') !== ''
                                && Number(that.model.get('appointment_id')) === event.appointment_id) {
                                // ...except it's the appointment of the own booking (add)
                                selectedPersCount = Number(that.model.get('amount'));
                                available_pers_count += selectedPersCount;
                            }
                        }

                        // @todo If its a new booking, show already selected amount
                        //  If id === '' && start === this.model.get('begin') && event.id === this.model.get('event_id')
                        // -> selectedPersCount = Number(that.model.get('amount'))

                        ddText += `
                      <div
                          class="single-appointment clearfix"
                          data-day="${ddId}"
                          data-apptId="${event.id}">
                          <div class="single-appointment-desc float-left">
                              <strong>${event.title}</strong>
                              <br />
                              <span
                                  class="single-appointment-time"
                                  title="${start.toISOString()} - ${end.toISOString()}">
                                  ${start.format('HH:mm')} - ${end.format('HH:mm')}
                                  ${selectedPersCount>=1 ? '(' + t('selected_${a}',{a:selectedPersCount}) + ')' : ''}
                              </span>
                          </div>
                          <div class="single-appointment-data float-right">
                              <select
                                  id="single-appointment-data-perscount"
                                  name="perscount">`;

                        for (let i: number = 1; i <= available_pers_count; i++) {
                            ddText += `
                                  <option value="${i}"${(i==selectedPersCount ? ' selected="selected"' : '')}>
                                      ${i} ${t('pers_short')}
                                  </option>`;
                        }

                        ddText += `
                              </select>
                              <button class="button${selectedPersCount === 0 ? ' hollow' : ''} secondary small">
                                  <i class="fi fi-check"></i>
                              </button>
                          </div>
                      </div>`;
                    });

                    ddText += '</div>';

                    // #inb-c
                    $('body').append(ddText);

                    that._openPopup = $(`#dd-${ddId}`);

                    // Attach event listeners
                    that._openPopup.on('click', (ev: any): void => {
                        // Else, any click on _openPopup > * would close the datepicker
                        // -> set _allowCalClose in the following events themselfs.
                        that._allowCalClose = false;
                    });

                    // NOT COOL, use native InboomaBaseView for that!
                    that._openPopup.find('.single-appointment button').on('click', (ev: any): void => {
                        that._allowCalClose = true;
                        that._singleAppointmentClick($(ev.currentTarget).closest('.single-appointment'));
                        that.datepicker.hide();
                        that._openPopup.remove();
                    });

                    that._openPopup.find('.button-abort').on('click', (): void => {
                        that._allowCalClose = false;
                        that._openPopup.remove();

                        setTimeout((): void => {
                            // After that, reset _allowCalClose
                            that._allowCalClose = true;
                        }, 100);
                    });

                    that._openPopup.find('#single-appointment-data-perscount').on('change', (ev: any): void => {
                        $(ev.currentTarget).focus();
                        $(ev.currentTarget).closest('.single-appointment-data')
                            .find('.button')
                            .removeClass('secondary');
                    });

                    that._openPopup.find('#single-appointment-data-perscount').on('click', (ev: any): void => {
                        ev.preventDefault();
                        $(ev.currentTarget).focus();
                    });

                }

                this.hide();
            },
            onClose (): void {
                if (!that._allowCalClose) {
                    // @ts-ignore
                    this.show();
                } else {
                    that._removeDomSpam();
                }
            },
            /**
             * Should a single day be marked as active/available or not (=> true)?
             * @param {Date} day
             */
            disableDayFn (day: any): boolean {

                const _day: any = moment(day).format('Y-MM-DD');

                if (typeof that._sortedEvents[_day] === 'undefined' || that._sortedEvents[_day].length === 0) {
                    return true;
                }

                return false;
            }
        });

        return this;
    }

});
